// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/rfi_packages.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * Proposed composition only; no submission or source/working document mutations.
 *
 * @generated from message mono.datagateway.v1.RfiPackage
 */ export class RfiPackage extends Message {
    static fromBinary(bytes, options) {
        return new RfiPackage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiPackage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiPackage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiPackage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string request_id = 4;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string created_by = 5;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.RfiPackageItem items = 7;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiPackage, "runtime", proto3);
_define_property(RfiPackage, "typeName", "mono.datagateway.v1.RfiPackage");
_define_property(RfiPackage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "items",
            kind: "message",
            T: RfiPackageItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiPackageItem
 */ export class RfiPackageItem extends Message {
    static fromBinary(bytes, options) {
        return new RfiPackageItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiPackageItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiPackageItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiPackageItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string package_id = 2;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * section_version | generated_artifact | external_artifact |
   * response_document_version (WRT-16: the whole response document at a
   * version; section_id is ""). A generated_artifact made from a
   * response_document_version item also has section_id "".
   *
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string section_id = 5;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string document_id = 6;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string document_version_id = 7;
   */ _define_property(this, "documentVersionId", ""), /**
   * @generated from field: string artifact_id = 8;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 artifact_version = 9;
   */ _define_property(this, "artifactVersion", 0), /**
   * @generated from field: string content_sha256 = 10;
   */ _define_property(this, "contentSha256", ""), /**
   * not_validated for supported DOCX; unsupported for external uploads.
   *
   * @generated from field: string validation_status = 11;
   */ _define_property(this, "validationStatus", ""), /**
   * @generated from field: string filename = 12;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string created_by = 13;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * WRT-16 (OD-75): docx | pdf | xlsx | pptx | as_stored; "" reads docx.
   *
   * @generated from field: string export_format = 15;
   */ _define_property(this, "exportFormat", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiPackageItem, "runtime", proto3);
_define_property(RfiPackageItem, "typeName", "mono.datagateway.v1.RfiPackageItem");
_define_property(RfiPackageItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "document_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "artifact_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "validation_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "export_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiPackagesRequest
 */ export class ListRfiPackagesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiPackagesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiPackagesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiPackagesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiPackagesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiPackagesRequest, "runtime", proto3);
_define_property(ListRfiPackagesRequest, "typeName", "mono.datagateway.v1.ListRfiPackagesRequest");
_define_property(ListRfiPackagesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiPackagesResponse
 */ export class ListRfiPackagesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiPackagesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiPackagesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiPackagesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiPackagesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiPackage packages = 1;
   */ _define_property(this, "packages", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiPackagesResponse, "runtime", proto3);
_define_property(ListRfiPackagesResponse, "typeName", "mono.datagateway.v1.ListRfiPackagesResponse");
_define_property(ListRfiPackagesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "packages",
            kind: "message",
            T: RfiPackage,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRfiPackageRequest
 */ export class CreateRfiPackageRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiPackageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiPackageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiPackageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiPackageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string request_id = 4;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string name = 5;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiPackageRequest, "runtime", proto3);
_define_property(CreateRfiPackageRequest, "typeName", "mono.datagateway.v1.CreateRfiPackageRequest");
_define_property(CreateRfiPackageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRfiPackageResponse
 */ export class CreateRfiPackageResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiPackageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiPackageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiPackageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiPackageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiPackage package = 1;
   */ _define_property(this, "package", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiPackageResponse, "runtime", proto3);
_define_property(CreateRfiPackageResponse, "typeName", "mono.datagateway.v1.CreateRfiPackageResponse");
_define_property(CreateRfiPackageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "package",
            kind: "message",
            T: RfiPackage
        }
    ]));
/**
 * Internal trusted receipt: Zou must read the exact immutable version through
 * DocumentsService before supplying document identity/hash. Browser has no receipt API.
 *
 * @generated from message mono.datagateway.v1.AddRfiPackageItemRequest
 */ export class AddRfiPackageItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddRfiPackageItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddRfiPackageItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddRfiPackageItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddRfiPackageItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: mono.datagateway.v1.RfiPackageItem item = 4;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddRfiPackageItemRequest, "runtime", proto3);
_define_property(AddRfiPackageItemRequest, "typeName", "mono.datagateway.v1.AddRfiPackageItemRequest");
_define_property(AddRfiPackageItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "item",
            kind: "message",
            T: RfiPackageItem
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddRfiPackageItemResponse
 */ export class AddRfiPackageItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddRfiPackageItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddRfiPackageItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddRfiPackageItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddRfiPackageItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiPackageItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddRfiPackageItemResponse, "runtime", proto3);
_define_property(AddRfiPackageItemResponse, "typeName", "mono.datagateway.v1.AddRfiPackageItemResponse");
_define_property(AddRfiPackageItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: RfiPackageItem
        }
    ]));
/**
 * Immutable snapshot of an explicit selection of existing RFI-10 package items.
 *
 * @generated from message mono.datagateway.v1.RfiPackageVersion
 */ export class RfiPackageVersion extends Message {
    static fromBinary(bytes, options) {
        return new RfiPackageVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiPackageVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiPackageVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiPackageVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string package_id = 3;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: string request_id = 4;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: repeated string item_ids = 5;
   */ _define_property(this, "itemIds", []), /**
   * @generated from field: string name = 6;
   */ _define_property(this, "name", ""), /**
   * @generated from field: repeated mono.datagateway.v1.RfiPackageItem items = 7;
   */ _define_property(this, "items", []), /**
   * @generated from field: string created_by = 8;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiPackageVersion, "runtime", proto3);
_define_property(RfiPackageVersion, "typeName", "mono.datagateway.v1.RfiPackageVersion");
_define_property(RfiPackageVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "item_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "items",
            kind: "message",
            T: RfiPackageItem,
            repeated: true
        },
        {
            no: 8,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiSubmission
 */ export class RfiSubmission extends Message {
    static fromBinary(bytes, options) {
        return new RfiSubmission().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiSubmission().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiSubmission().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiSubmission, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string package_id = 3;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: string package_version_id = 4;
   */ _define_property(this, "packageVersionId", ""), /**
   * @generated from field: string supersedes_id = 5;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: string request_id = 6;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 7;
   */ _define_property(this, "submittedAt", void 0), /**
   * Actual submitter, independently of the authenticated user recording the act.
   *
   * @generated from field: string submitted_by = 8;
   */ _define_property(this, "submittedBy", ""), /**
   * @generated from field: string channel = 9;
   */ _define_property(this, "channel", ""), /**
   * @generated from field: string recipient = 10;
   */ _define_property(this, "recipient", ""), /**
   * @generated from field: string receipt_reference = 11;
   */ _define_property(this, "receiptReference", ""), /**
   * @generated from field: string notes = 12;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string recorded_by = 13;
   */ _define_property(this, "recordedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp recorded_at = 14;
   */ _define_property(this, "recordedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiSubmission, "runtime", proto3);
_define_property(RfiSubmission, "typeName", "mono.datagateway.v1.RfiSubmission");
_define_property(RfiSubmission, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "package_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "submitted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "submitted_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "channel",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "recipient",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "receipt_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "recorded_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiSubmissionReceipt
 */ export class RfiSubmissionReceipt extends Message {
    static fromBinary(bytes, options) {
        return new RfiSubmissionReceipt().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiSubmissionReceipt().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiSubmissionReceipt().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiSubmissionReceipt, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string submission_id = 2;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string reference = 4;
   */ _define_property(this, "reference", ""), /**
   * @generated from field: string notes = 5;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string recorded_by = 6;
   */ _define_property(this, "recordedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp recorded_at = 7;
   */ _define_property(this, "recordedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiSubmissionReceipt, "runtime", proto3);
_define_property(RfiSubmissionReceipt, "typeName", "mono.datagateway.v1.RfiSubmissionReceipt");
_define_property(RfiSubmissionReceipt, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "recorded_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureRfiPackageVersionRequest
 */ export class CaptureRfiPackageVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CaptureRfiPackageVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureRfiPackageVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureRfiPackageVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureRfiPackageVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string package_id = 4;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: string request_id = 5;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: repeated string item_ids = 6;
   */ _define_property(this, "itemIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureRfiPackageVersionRequest, "runtime", proto3);
_define_property(CaptureRfiPackageVersionRequest, "typeName", "mono.datagateway.v1.CaptureRfiPackageVersionRequest");
_define_property(CaptureRfiPackageVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "item_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureRfiPackageVersionResponse
 */ export class CaptureRfiPackageVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CaptureRfiPackageVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureRfiPackageVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureRfiPackageVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureRfiPackageVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiPackageVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureRfiPackageVersionResponse, "runtime", proto3);
_define_property(CaptureRfiPackageVersionResponse, "typeName", "mono.datagateway.v1.CaptureRfiPackageVersionResponse");
_define_property(CaptureRfiPackageVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: RfiPackageVersion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiPackageVersionRequest
 */ export class GetRfiPackageVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiPackageVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiPackageVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiPackageVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiPackageVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiPackageVersionRequest, "runtime", proto3);
_define_property(GetRfiPackageVersionRequest, "typeName", "mono.datagateway.v1.GetRfiPackageVersionRequest");
_define_property(GetRfiPackageVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiPackageVersionResponse
 */ export class GetRfiPackageVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiPackageVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiPackageVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiPackageVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiPackageVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiPackageVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiPackageVersionResponse, "runtime", proto3);
_define_property(GetRfiPackageVersionResponse, "typeName", "mono.datagateway.v1.GetRfiPackageVersionResponse");
_define_property(GetRfiPackageVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: RfiPackageVersion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordRfiSubmissionRequest
 */ export class RecordRfiSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: mono.datagateway.v1.RfiSubmission submission = 4;
   */ _define_property(this, "submission", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiSubmissionRequest, "runtime", proto3);
_define_property(RecordRfiSubmissionRequest, "typeName", "mono.datagateway.v1.RecordRfiSubmissionRequest");
_define_property(RecordRfiSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "submission",
            kind: "message",
            T: RfiSubmission
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordRfiSubmissionResponse
 */ export class RecordRfiSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiSubmission submission = 1;
   */ _define_property(this, "submission", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiSubmissionResponse, "runtime", proto3);
_define_property(RecordRfiSubmissionResponse, "typeName", "mono.datagateway.v1.RecordRfiSubmissionResponse");
_define_property(RecordRfiSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission",
            kind: "message",
            T: RfiSubmission
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiSubmissionsRequest
 */ export class ListRfiSubmissionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSubmissionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSubmissionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSubmissionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSubmissionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSubmissionsRequest, "runtime", proto3);
_define_property(ListRfiSubmissionsRequest, "typeName", "mono.datagateway.v1.ListRfiSubmissionsRequest");
_define_property(ListRfiSubmissionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiSubmissionsResponse
 */ export class ListRfiSubmissionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSubmissionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSubmissionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSubmissionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSubmissionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiSubmission submissions = 1;
   */ _define_property(this, "submissions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSubmissionsResponse, "runtime", proto3);
_define_property(ListRfiSubmissionsResponse, "typeName", "mono.datagateway.v1.ListRfiSubmissionsResponse");
_define_property(ListRfiSubmissionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submissions",
            kind: "message",
            T: RfiSubmission,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AppendRfiSubmissionReceiptRequest
 */ export class AppendRfiSubmissionReceiptRequest extends Message {
    static fromBinary(bytes, options) {
        return new AppendRfiSubmissionReceiptRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppendRfiSubmissionReceiptRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppendRfiSubmissionReceiptRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppendRfiSubmissionReceiptRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string package_id = 4;
   */ _define_property(this, "packageId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiSubmissionReceipt receipt = 5;
   */ _define_property(this, "receipt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AppendRfiSubmissionReceiptRequest, "runtime", proto3);
_define_property(AppendRfiSubmissionReceiptRequest, "typeName", "mono.datagateway.v1.AppendRfiSubmissionReceiptRequest");
_define_property(AppendRfiSubmissionReceiptRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "package_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "receipt",
            kind: "message",
            T: RfiSubmissionReceipt
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AppendRfiSubmissionReceiptResponse
 */ export class AppendRfiSubmissionReceiptResponse extends Message {
    static fromBinary(bytes, options) {
        return new AppendRfiSubmissionReceiptResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppendRfiSubmissionReceiptResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppendRfiSubmissionReceiptResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppendRfiSubmissionReceiptResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiSubmissionReceipt receipt = 1;
   */ _define_property(this, "receipt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AppendRfiSubmissionReceiptResponse, "runtime", proto3);
_define_property(AppendRfiSubmissionReceiptResponse, "typeName", "mono.datagateway.v1.AppendRfiSubmissionReceiptResponse");
_define_property(AppendRfiSubmissionReceiptResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "receipt",
            kind: "message",
            T: RfiSubmissionReceipt
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiSubmissionReceiptsRequest
 */ export class ListRfiSubmissionReceiptsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSubmissionReceiptsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSubmissionReceiptsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSubmissionReceiptsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSubmissionReceiptsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string submission_id = 3;
   */ _define_property(this, "submissionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSubmissionReceiptsRequest, "runtime", proto3);
_define_property(ListRfiSubmissionReceiptsRequest, "typeName", "mono.datagateway.v1.ListRfiSubmissionReceiptsRequest");
_define_property(ListRfiSubmissionReceiptsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiSubmissionReceiptsResponse
 */ export class ListRfiSubmissionReceiptsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSubmissionReceiptsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSubmissionReceiptsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSubmissionReceiptsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSubmissionReceiptsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiSubmissionReceipt receipts = 1;
   */ _define_property(this, "receipts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSubmissionReceiptsResponse, "runtime", proto3);
_define_property(ListRfiSubmissionReceiptsResponse, "typeName", "mono.datagateway.v1.ListRfiSubmissionReceiptsResponse");
_define_property(ListRfiSubmissionReceiptsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "receipts",
            kind: "message",
            T: RfiSubmissionReceipt,
            repeated: true
        }
    ]));
